import {
  InnerContent,
  PanelScrollBody,
  Props,
  Wrapper,
} from "./PanelContent.Parts";

export const PanelContent = ({ children }: Props) => {
  return (
    <Wrapper>
      <InnerContent>
        <PanelScrollBody>{children}</PanelScrollBody>
      </InnerContent>
    </Wrapper>
  );
};
